module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ftit"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("B"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("IOGRAPHICAL")]), _vm._v(" N"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("OTE ON")]), _vm._v(" W. F. O"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("SCAR")]), _vm._v(" F"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("EDERHEN AND")]), _vm._v(" F"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("AMILY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("W"), _c('span', {
    staticClass: "chsmallb"
  }, [_vm._v("ILLIAM")]), _vm._v(" F"), _c('span', {
    staticClass: "chsmallb"
  }, [_vm._v("RANCIS")])]), _vm._v(" Oscar Federhen (rhymes with “veteran”) was born in the 1840s in Boston, Massachusetts, to Jacob and Elizabeth Federhen. Jacob worked as a jeweler in Boston for most of his life and died in 1860.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oscar’s exact age is a small mystery. He declared a birth date of September 17, 1844, at his enlistment. His gravestone, however, has 1843 as his year of birth, but he claimed he was 21 when he got married on January 1, 1867. An older brother, William F. Federhen, was born in 1841 and died four years later in 1845 from croup. As a result, it seems likely that William Francis Oscar Federhen was born in 1846 and named for his late brother. Oscar’s other siblings included Jacob (born 1839), Anna (1840-1922), George (Jan. 26, 1850), and Frank (1854)."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oscar’s brother Jacob enlisted in the 1st Massachusetts Light Artillery on April 20, 1861, for 90 days and was immediately dispatched to Baltimore to preserve the federal government’s control over the city. (Jacob’s early enlistment"), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v(" qualified him for the Massachusetts Minute Man Medal, issued in 1902.) He reenlisted for three years with the rank of Quartermaster Sergeant on August 28, 1861. The history of Jacob’s battery is one of continuous engagement. It saw service with the Army of the Potomac in nearly every major battle in the Eastern Theater. He was promoted to 2nd Lt. on September 23, 1861, and 1st Lt. a year later after Crampton’s Gap. He was wounded through both thighs at Spotsylvania in May 1864 and mustered out of service that October 19."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jacob lived in Boston after the war, married, and moved to Kansas. In 1885 he filed for a pension as an invalid and received $12.75 per month. He died on November 28, 1915.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for Oscar, nothing of substance is known of his prewar years. He appeared on a list of men subject to the draft in May or June of 1863 and enlisted as a private in the 13th Independent Battery, Massachusetts Light Artillery on March 25, 1864, noting his occupation as “brass finisher.” U.S. Army records indicate that he was made a prisoner of war on May 3, 1864, “while en route to battery,” and that he “escaped on June 3, 1865.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After he rejoined his battery during the waning days of war, Oscar was mustered out on July 28, 1865. The U.S. Army confirmed his status as a prisoner of war.")]), _vm._v(" "), _c('p', {
    staticClass: "notet"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Ancestry.com")])])]), _vm._v(": Massachusetts, U.S., Town and Vital Records, 1620-1988.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(" Massachusetts Adjutant General’s Office, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts Soldiers, Sailors, and Marines in the Civil War")]), _vm._v(" (Norwood, MA: Norwood Press), 1931; Dean Sargent, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Army of the Republic: Civil War Veterans, Department of Massachusetts, 1866 to 1947")]), _vm._v(" (Bowie, MD: Heritage Books, 2002); "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://Ancestry.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Ancestry.com")])])]), _vm._v(": Massachusetts, Birth Records, 1840–1915; Massachusetts, Town and Vital Records, 1620–1988; Massachusetts, State Census, 1865; Massachusetts, Mason Membership Cards, 1733–1990; Kansas, Grand Army of the Republic Post Reports, 1880–1940; U.S. City Directories, 1822–1995; U.S., Civil War Pension Index: General Index to Pension Files, 1861–1934; U.S. Civil War Soldiers, 1861–1865; U.S. Civil War Soldier Records and Profiles, 1861– 1865; U.S., Civil War Draft Registrations Records, 1863–1865.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-557facf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Biographical_Note.vue
// module id = 87
// module chunks = 0